module.exports = __webpack_public_path__ + "img/guide-cod-1.a6cbb816.png";